import * as ko from "knockout";
import Bao from "./bao-service";
function BaoShouter() {
    var self = this;
    var def = null;
    var timeoutRef = null;
    var templateAlert = "<div class='alert alert-dismissible' role='alert'>";
    var templateButton = "<button type='button' class='close' data-dismiss='alert'><span aria-hidden='true'>&times;</span><span class='sr-only'>Close</span></button>";
    var templateContainer = "<div style='position: fixed; top: 10px; left: 0; right: 0; margin: 0 auto; width: 25%; min-width: 300px; display: none; text-align: center; z-index: 1001'>";
    var $container = $(templateContainer);
    var close = function () {
        clearTimeout(timeoutRef);
        $container.fadeOut(400, function () {
            def.resolve();
            def = null;
        });
    };
    var init = function () {
        $(document.body).append($container);
    };
    var setValues = function (text, type) {
        var $alert = $(templateAlert);
        var $button = $(templateButton);
        $container.detach();
        $container.empty();
        $container.append($alert);
        $alert.addClass("alert-" + type);
        $alert.append($button);
        $alert.append(text);
        $button.click(close);
        $(document.body).append($container);
    };
    self.show = function (text, type, duration) {
        if (def != null && def.state() == "pending") {
            clearTimeout(timeoutRef);
            def.resolve();
            def = null;
        }
        if (duration == null) {
            duration = 5;
        }
        if (type == null) {
            type = "success";
        }
        if (def == null || def.state() == "resolved") {
            def = $.Deferred();
            setValues(text, type);
            $container.fadeIn();
            if (duration > 0) {
                timeoutRef = setTimeout(function () {
                    close();
                }, duration * 1000);
            }
        }
        return def.promise();
    };
    init();
}
export default new BaoShouter();